import { Keys } from '../helpers/Keys';
import { Module } from '../Module';

interface IEditableTextareaScope extends ng.IScope {

  // Bound to attributes
  onBeforeSave: (params: { newText: string, $event: JQueryEventObject }) => ng.IPromise<any>;

  // Private
  busy: boolean;
  text: string;
  mode: string;
  readonly: boolean;
  maxCharacterLength: number;
  showProjectImageHint: boolean;
  exceededMaxCharacterLength: () => boolean;

  edit: () => void;
  preview: () => void;
  save: ($event: JQuery.Event) => void;
  cancel: () => void;
}

interface IEditableTextareaAttributes extends ng.IAttributes {
  disableEditButton: string;
  disablePreviewMode: string;
  buttonContainer: string;
}

const MAX_CHARACTER_LENGTH_DEFAULT: number = 50000;
const ViewMode = 'view',
  EditMode = 'edit',
  PreviewMode = 'preview';

Module.instance().directive('tbEditableTextarea', <any[]>[
  '$timeout',
  ($timeout: ng.ITimeoutService) => {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'editableTextarea.html',
      scope: {
        onBeforeSave: '&',
        disableEditButton: '=?',
        maxCharacterLength: '=?',
        showProjectImageHint: '=?',
        disablePreviewMode: '=?',
        mode: '=?'
      },
      require: 'ngModel',
      link: ($scope: IEditableTextareaScope, element: JQuery, attrs: IEditableTextareaAttributes, ctrl: ng.INgModelController) => {

        attrs.$observe('readonly', (attrReadonly: any) => {
          $scope.readonly = !!attrReadonly;
          element.toggleClass('tb-readonly', $scope.readonly);
        });

        // If the "button-container" attribute is supplied, move the buttons to that container
        if (attrs.buttonContainer) {
          const buttons = element.find('.tb-editable-textarea-buttons');
          buttons.appendTo($(attrs.buttonContainer));
        }

        if(!$scope.maxCharacterLength) {
          $scope.maxCharacterLength = MAX_CHARACTER_LENGTH_DEFAULT;
        }

        $scope.exceededMaxCharacterLength = () => $scope.text && $scope.text.length > $scope.maxCharacterLength;

        $scope.mode = ViewMode;
        const textarea = element.find('textarea');

        $scope.busy = false;

        ctrl.$render = () => {
          $scope.text = ctrl.$viewValue;
        };

        $scope.edit = () => {
          if($scope.readonly) return;

          if ($scope.mode === ViewMode) {
            $scope.text = ctrl.$viewValue;
          }
          $scope.mode = EditMode;
          $timeout(() => textarea.focus());
        };

        $scope.preview = () => {
          $scope.mode = PreviewMode;
        };

        $scope.save = ($event: JQueryEventObject) => {
          $scope.busy = true;

          const newText = $scope.text;
          $scope.onBeforeSave({ newText: $scope.text, $event }).then(
            // Success
            () => {
              ctrl.$setViewValue(newText);
              $scope.mode = ViewMode;
              $scope.busy = false;
            },
            // Error
            () => {
              // TODO: show error message
              $scope.busy = false;
            }
            );
        };

        $scope.cancel = () => {
          $scope.text = ctrl.$viewValue; // Restore the original value
          $scope.mode = ViewMode;
        };

        // Keyboard handling
        textarea.on('keydown', ($event: JQuery.Event) => {
          switch ($event.which) {

            // Save on Ctrl-Enter
            case Keys.Enter:
              if ($event.ctrlKey) {
                $scope.$apply(() => $scope.save($event));
              }
              break;

            // Cancel on escape
            case Keys.Escape:
              $scope.$apply(() => $scope.cancel());
              break;
          }
        });
      }
    };
  }
]);
